<template>
  <div class="index-container">
    <div class="third-line">
      <img src="@/assets/index/dpsy-banner.png" alt />
    </div>
    <div class="second-line">
      <div
        v-for="second in secondLines"
        :key="second.title"
        @click="goSecondLine(second.title)"
      >
        <img :src="second.imgUrl" alt />
        <p>{{ second.title }}</p>
      </div>
    </div>

    <img
      :src="require('@/assets/index/congress.webp')"
      class="party_history_img"
      @click="goThemeEdu(0)"
    />

    <!-- 直播入口 -->
    <div v-if="livingIsShow" class="living-entry" @click="toLivingPage">
      <div class="living-entry-left">
        <p class="living-entry-label">【直播会议】</p>
        <p class="living-entry-title">{{ `${liveTheme}` }}</p>
      </div>
      <img class="living-entry-icon" src="@/assets/home_icon_live.webp" alt />
    </div>
    <div class="six-line">
      <div class="choose-state">
        <el-select v-model="value">
          <el-option
            v-for="item in sixLine"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="look-all" style="margin-right: 0.2rem" @click="goList">
        查看全部
        <i class="el-icon-right"></i>
      </div>
    </div>
    <div class="seven-line">
      <div
        class="news-template"
        v-for="news in sevenLine"
        :key="news.id"
        @click="goDetail(news)"
      >
        <div class="news-left">
          <img
            :src="news.img | img"
            alt
            v-if="news.img == null ? false : true"
          />
        </div>
        <div class="news-right">
          <p>{{ news.headline }}</p>
          <p>
            <span style="margin-right: 0.3rem; float: right">{{
              news.createtime | times
            }}</span>
          </p>
        </div>
      </div>
    </div>

    <div class="QRcode-img">
      <div @click="toQRcode" class="dialog"></div>
    </div>

    <!-- dialog -->
    <el-dialog title="" :visible.sync="dialogTableVisible">
      <div class="dialog-imgbox">
        <img src="@/assets/index/bg-erw.png" alt="" />
      </div>
    </el-dialog>

    <Panoramic v-if="meetingPanoramicShow" :coefficientHeight="0.7">
      <template #icon>
        <img
          :src="require('@/assets/index/panoramic-img.png')"
          fit="panoramic-img"
          class="panoramic-img"
          @click="toMeeting"
        />
      </template>
    </Panoramic>
  </div>
</template>

<script>
import { handleForceLogin } from "@/api/dpModule";
import { getLivingPath } from "@/api/living";

import { aesDecrypt, timeToSc, formatDate } from "@/utils/common";

// import LivingPlayer from '@/components/livingPlayer/LivingPlayer'
import livingVideoPlayer from "@/components/livingVideoPlayer";
import Panoramic from "@/components/common/Panoramic.vue";

export default {
  components: {
    // LivingPlayer,
    livingVideoPlayer,
    Panoramic,
  },
  data() {
    return {
      input: "",
      newsid: "",
      page: 1,
      sevenLine: [
        {
          imgUrl: require("@/assets/index/dpsy-photo1.png"),
          title:
            "新闻办举行庆祝中华人民共和国成立70周年活动有关情况发新闻办举行庆祝中华人民共和国成立70周年活动有关情况发",
          see: 32,
          praise: 12,
          time: "2019-11-8",
        },
      ],
      value: "新闻动态",
      sixLine: [
        {
          value: "新闻动态",
          label: "新闻动态",
        },
        // {
        //   value: "地方文件",
        //   label: "地方文件"
        // },
        // {
        //   value: "中央精神",
        //   label: "中央精神"
        // }
      ],
      fourLines: [
        { imgUrl: require("@/assets/party-history.webp") },
        // { imgUrl: require("@/assets/index/dp-yq-banner2.png") },
      ],
      secondLines: [
        {
          imgUrl: require("@/assets/index/dpsy-icon-fg.png"),
          title: "党政机构",
        },
        {
          imgUrl: require("@/assets/index/dpsy-icon-qn.png"),
          title: "青年党支部",
        },
        {
          imgUrl: require("@/assets/index/dpsy-icon-fw.png"),
          title: "便民服务",
        },
        {
          imgUrl: require("@/assets/index/dpsy-icon-jx.png"),
          title: "美丽家乡",
        },
        {
          imgUrl: require("@/assets/index/dpsy-icon-rc.png"),
          title: "人才之家",
        },
        {
          imgUrl: require("@/assets/index/dpsy-icon-zhiy.png"),
          title: "志愿服务",
        },
        {
          imgUrl: require("@/assets/index/dpsy-icon-liangx.png"),
          title: "两新党建",
        },
        {
          imgUrl: require("@/assets/index/dpsy-icon-rd.png"),
          title: "在线入党",
        },
      ],
      dialogTableVisible: false,
      showPosi: true,
      moveWay: {
        top: 10 + "rem",
        left: 4 + "rem",
        position: "fixed",
      },
      statuCode: 1,
      id: "",
      cDay: "",
      cHour: "",
      cMinute: "",
      cSecond: "",
      timer: null,
      starttime: "2021-12-08 00:00:00",
      endtime: "2021-12-08 20:00:00",
      isiOS: false,
      playShow: false,
      livingPath: "",
      livingCover: "",
      playType: "img",
      // 直播卡片 mock 数据（接口无值时兜底展示）
      liveTheme: "",
      liveArea: "东坡区",
      liveTitle: "2026年基层党员全覆盖培训班（第一期）",
      livingArea: "",
    };
  },
  computed: {
    meetingPanoramicShow() {
      const nowMs = new Date().getTime() / 3600 / 1000;
      return nowMs < timeToSc("2025-01-01 00:00:00");
    },
    livingHasRole() {
      // 游客无直播观看权限
      return sessionStorage.getItem("name") !== "游客";
    },
    livingIsShow() {
      if (!this.endtime) return false;
      return new Date().getTime() / 3600 / 1000 < timeToSc(this.endtime);
    },
  },
  created() {
    this.statuCode = sessionStorage.getItem("statuCode");
    this.id = sessionStorage.getItem("id");
    this.getLivingPath();
  },
  methods: {
    toMeeting() {
      this.$router.push({
        path: "/meeting",
        query: { title: "学习贯彻党的二十届三中全会精神培训课程" },
      });
    },
    toObjects() {
      this.$router.push({
        path: "/objects",
        query: { title: "党务干部培训班知识竞赛" },
      });
    },
    getLivingPath() {
      // 获取直播播放地址
      getLivingPath()
        .then((res) => {
          console.log("[LiveVideo] 接口返回:", res);
          if (res && res.msg && res.msg.newpath) {
            res.msg.newpath.indexOf("mp4") === -1
              ? (this.playType = "img")
              : (this.playType = "mp4");
            this.livingPath = res.msg.newpath;
            this.livingCover = `http://qswgadmin.djplus.cn//Tittle/${res.msg.imgurl}`;
          }
        })
        .catch((err) => {
          console.error("[LiveVideo] 接口异常:", err);
        });
      // 获取直播时间与元信息
      this.axios
        .get(`/api/Index/PlayTime`)
        .then((response) => {
          const res = response.data;
          const pid = res?.msg?.Pid || 0;
          this.livePid = pid;
          const { StartTime, EndTime, Pname, LiveRoomID, LiveMemo, LiveName } =
            res?.msg || {};
          const [liveArea, liveTitle] = (LiveMemo || "").split(",");
          this.liveTheme = LiveName;
          this.liveArea = liveArea;
          this.liveTitle = liveTitle;
          this.livingRole = Pname || "";
          this.livingArea = LiveRoomID || "";
          this.starttime = formatDate(StartTime, "yyyy-MM-dd hh:mm:ss");
          this.endtime = formatDate(EndTime, "yyyy-MM-dd hh:mm:ss");
        })
        .catch((err) => {
          console.error("[PlayTime] 接口异常:", err);
        });
    },
    addZero(val) {
      return val < 10 ? "0" + val : val;
    },
    countDown2() {
      this.judgeDevice();
      // eslint-disable-next-line no-useless-escape
      const startTime = this.isiOS
        ? new Date(this.starttime.replace(/\-/g, "/"))
        : new Date(this.starttime);
      // eslint-disable-next-line no-useless-escape
      const endTime = this.isiOS
        ? new Date(this.endtime.replace(/\-/g, "/"))
        : new Date(this.endtime);
      const nowTime = new Date();
      // 距离 开始
      const beginDiff = parseInt(
        (startTime.getTime() - nowTime.getTime()) / 1000,
      );
      // 距离 结束
      const endDiff = parseInt((endTime.getTime() - nowTime.getTime()) / 1000);
      // 剩余时间
      const leftTime = beginDiff > 0 ? beginDiff : endDiff;
      this.cDay = this.addZero(parseInt(leftTime / (24 * 60 * 60)));
      this.cHour = this.addZero(parseInt((leftTime / (60 * 60)) % 24));
      this.cMinute = this.addZero(parseInt((leftTime / 60) % 60));
      this.cSecond = this.addZero(parseInt(leftTime % 60));
      if (endDiff > 0) {
        this.playShow = false;
      } else this.playShow = true;

      if (beginDiff > 0) {
        this.timer = setTimeout(this.countDown2, 1000);
      } else if (leftTime <= 0) {
        clearTimeout(this.timer);
        this.playShow = true;
      } else {
        this.timer = setTimeout(this.countDown2, 1000);
      }
    },
    judgeDevice() {
      const u = navigator.userAgent;
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    },
    goSecondLine(item) {
      switch (item) {
        case "党政机构":
          window.open("https://www.dp.gov.cn/dzjg.htm");
          break;
        case "青年党支部":
          this.$router.push({
            path: "youthpartybrach",
            query: { title: item },
          });
          break;
        case "美丽家乡":
          this.$router.push({
            path: "/beautiful",
            query: { title: item },
          });
          break;
        case "便民服务":
          this.$router.push({
            path: "/convenienceserve",
            query: { title: item },
          });
          break;
        case "两新党建":
          this.$router.push({
            path: "/twoStar",
            query: { title: item },
          });
          break;
        case "人才之家":
          this.$router.push({
            path: "/dpTalent",
            query: { title: item },
          });
          break;
        case "志愿服务":
          console.log(sessionStorage.getItem("name"));
          if (sessionStorage.getItem("name") == "游客") {
            /* this.$message({
              message: "游客无法使用，请登录！",
              type: "error",
              offset: 300,
            }); */
            this.$router.push({
              path: "/loginDp",
            });
          } else {
            let params = { userid: Number(this.id) };
            handleForceLogin(params).then((res) => {
              const { code, msg, token } = res;
              if (code == 0) {
                const aesField = [
                  "c1name",
                  "c1phone",
                  "c2community",
                  "c2province",
                  "c2street",
                  "c2village",
                ];
                const userInfo = {};
                for (const key in msg) {
                  userInfo[key] = aesField.includes(key)
                    ? aesDecrypt(msg[key])
                    : msg[key];
                }
                this.$store.commit("perfectUserMsgs", userInfo);
                sessionStorage.setItem("c2userid", userInfo.c2userid);
                sessionStorage.setItem("c1roleid", userInfo.c1roleid);
                sessionStorage.setItem("c2token", aesDecrypt(token));
                sessionStorage.setItem("c2province", userInfo.c2province);
                sessionStorage.setItem("c2street", userInfo.c2street);
                sessionStorage.setItem("c2community", userInfo.c2community);
                sessionStorage.setItem("c2village", userInfo.c2village);
                this.$router.push({
                  path: "/partyReport",
                  query: { title: item },
                });
              } else if (code == 1) {
                this.$router.push({
                  path: "/perfectMsgLogin",
                });
              }
            });
          }
          break;
        case "在线入党":
          if (sessionStorage.getItem("status") != 0) {
            alert("您无法使用该功能");
            return;
          }
          this.$router.push({
            path: "/index/joinparty",
            query: { title: item },
          });
          break;
      }
    },
    goList() {
      this.$router.push({
        path: "publicList",
        query: { url: "/api/Main/NewsList", title: "新闻动态" },
      });
    },
    goDetail(news) {
      this.$router.push({
        path: "/publicDetail",
        query: { title: "新闻动态", id: news.id, dbnum: 0 },
      });
    },
    goThemeEdu(index) {
      switch (index) {
        case 0:
          this.$router.push({
            path: "meeting",
            query: { title: "学习贯彻党的二十届四中全会精神培训课程" },
          });
          // window.location.href = 'https://www.12371.cn/dsxx/'
          break;
        case 1:
          this.$router.push({
            path: "/index/epidmic/epidmic",
            query: { title: "坚决打赢疫情防控阻击战" },
          });
        default:
          break;
      }
    },
    goPartyAllience() {
      this.$router.push({
        path: "partyAllience",
        query: { title: "党建联盟" },
      });
    },
    goStudy() {
      this.$router.push({
        path: "/study/index",
        query: {
          title: "智慧党建学习班",
        },
      });
    },
    goTwoStar() {
      this.$router.push({
        path: "/twoStar",
        query: {
          title: "两新党建",
        },
      });
    },

    //点击触发dialog
    toQRcode() {
      this.dialogTableVisible = true;
    },
    goPartyReport() {
      if (sessionStorage.getItem("name") == "游客") {
        this.$message({
          message: "游客无法使用，请登录！",
          type: "error",
          offset: 300,
        });
      } else {
        this.$router.push({
          path: "partyReport",
          query: { title: "东坡志愿服务活动" },
        });
      }
    },
    //浮窗
    handleTouchStart(e) {
      this.moveWay.position = "position";
      this.moveWay.left = e.changedTouches[0].clientX - 80 + "px";
      this.moveWay.top = e.changedTouches[0].clientY - 80 + "px";
    },
    mousedown(e) {
      // this.clickTime = 0;
      // document.onmousemove = e => {
      //   this.clickTime = 1;
      //   this.moveWay.position = "position";
      //   this.moveWay.left = e.x - 200 + "px";
      //   this.moveWay.top = e.y - 100 + "px";
      // };
      // document.onmouseup = () => {
      //   if (this.clickTime) {
      //     document.onmousemove = null;
      //   } else {
      window.location.href = "http://www.gov.cn/zhuanti/2021qglh/index.htm";
      //   }
      // };
    },
    // 格式化日期时间
    formatDateTime(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    },
    // 跳转至直播页
    toLivingPage() {
      // console.log("sessionStorage.getItem", sessionStorage.getItem("status"));
      // if (sessionStorage.getItem("status") == 0) {
      //   this.$dialog.alert({
      //     message: "观看直播请先登录党员账号，感谢您的关注。",
      //     confirmButtonText: "确认",
      //   });
      //   return;
      // }
      this.$router.push({ path: "/living" });
    },
  },
  mounted: function () {
    this.countDown2();
    if (sessionStorage.getItem("token") == null) {
      this.$router.push("login");
    } else {
      this.axios
        .get(`/api/Main/News`)
        .then((e) => {
          if (e.data.code == 0) {
            // console.log(e.data);
            this.sevenLine = e.data.msg;
          } else {
            alert(e.data.msg);
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    }
  },
  destroyed() {
    clearTimeout(this.timer);
  },
};
</script>

<style lang="scss">
.index-container {
  padding-bottom: 1.5rem;
  .objects-img {
    position: fixed;
    right: 0;
    top: 10.2rem;
    z-index: 100;
    width: 3.42rem;
    height: 1.7rem;
  }
  .panoramic-img {
    width: 3.42rem;
    height: 1.7rem;
  }
  .grey-top {
    width: 100%;
    height: auto;
  }
  .seven-line {
    .news-template {
      width: 94%;
      margin: 0 auto;
      display: flex;
      margin-bottom: 0.2rem;
      background: #fff;
      padding: 0.2rem 0;
      border-radius: 0.16rem;
      //   align-items: center;
      .news-right {
        width: 100%;
        margin-left: 0.2rem;
        p:nth-child(1) {
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          display: -webkit-box;
          margin-bottom: 0.3rem;
          line-height: 1.8;
        }
        p:nth-child(2) {
          border-top: 0.01rem solid #e6e6e6;
          padding-top: 0.2rem;
          color: #999999;
          font-size: 0.26rem;
        }
      }
      .news-left {
        img {
          width: 2.4rem;
          height: 2rem;
        }
      }
    }
    margin-top: 0.3rem;
    // background: #fff;
  }
  .six-line {
    margin-top: 0.2rem;
    background: #fff;
    padding: 0.3rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    input {
      margin-left: 0.2rem;
      width: 2.5rem;
      font-weight: 600;
      border: none;
      font-size: 0.34rem;
    }
  }
  .five-line {
    margin-top: 0.3rem;
    background: #fff;
    padding: 0.3rem 0;
    text-align: center;
    img {
      width: 94%;
    }
  }
  .party_history_img {
    width: 100%;
    padding: 0 0.2rem;
    height: 2rem;
    margin-top: 0.2rem;
  }
  .four-line {
    .demonstration {
      font-weight: 600;
      font-size: 0.32rem;
      padding-left: 0.2rem;
      line-height: 3;
    }
    margin-top: 0.3rem;
    background: #fff;
    padding-bottom: 0.3rem;

    img {
      width: 100%;
      padding: 0 0.2rem;
      height: 2rem;
    }
  }
  .third-line {
    background: #fff;
    padding: 0.2rem 0;
    text-align: center;
    img {
      width: 94%;
      margin: 0 auto;
    }
  }
  .second-line {
    width: 100%;
    height: 3.94rem;
    background: url("../../assets/index/dpsy-topbg.png") center no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    font-size: 0.28rem;
    div {
      margin-top: 0.2rem;
      width: 25%;
      text-align: center;
      img {
        width: 0.9rem;
        height: 0.9rem;
      }
    }
  }
  font-size: 0.3rem;
  .first-line {
    padding-top: 0.2rem;
    background: #fff;
    align-items: center;
    .msgImg {
      width: 10%;
      text-align: center;
      img {
        width: 0.39rem;
        height: 0.33rem;
      }
    }
    .search {
      button {
        border: none;
        padding: 0.1rem 0.2rem;
        color: #fff;
        background: red;
        font-size: 0.28rem;
        border-radius: 0.08rem;
      }
      input {
        border-radius: 0.4rem;
        background: rgba($color: #dcdbdb, $alpha: 0.4);
      }
      // width: 54%;
      margin-left: auto;
    }
    .sign {
      img {
        width: 100%;
      }
      width: 26%;
      font-size: 0.2rem;
      text-align: center;
      margin-left: 0.2rem;
    }
    display: flex;
  }
  .QRcode-img {
    .dialog {
      width: 1.4rem;
      height: 1.4rem;
      background-color: pink;
      position: absolute;
      left: 0.6rem;
      top: 0.37rem;
      opacity: 0;
    }
    width: 100%;
    height: 2.16rem;
    background-image: url("../../assets/index/fotter-banner.png");
    background-size: 100% 100%;
    position: relative;
  }
  .dialog-imgbox {
    img {
      width: 4.95rem;
    }
    text-align: center;
  }
  .downloadIamge {
    img {
      height: 0.5rem;
      margin: 0.1rem 0.9rem 0.3rem 0;
    }
    text-align: right;
  }
  .el-dialog {
    .el-dialog__body {
      padding: 0;
    }
    width: 70%;
    text-align: center;
  }
  .partyAllience {
    &-posi {
      &-box {
        img {
          &:nth-child(1) {
            width: 0.4rem;
            height: 0.4rem;
            position: absolute;
            right: 0rem;
            top: -0.2rem;
          }
          &:nth-child(2) {
            width: 3rem;
            // height: 3.2rem;
            margin-top: 0.2rem;
          }
        }
        position: relative;
      }
      z-index: 1;
    }
  }
}

.example6-img {
  width: 96%;
  margin-left: 2%;
  margin-top: 10px;
  height: auto;
}

.living-entry {
  width: 96%;
  height: auto;
  min-height: 80px;
  margin: 20px auto 0;
  background-color: #fff;
  border-radius: 8px;
  padding: 16px 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  .living-entry-left {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    row-gap: 8px;
    overflow: hidden;
  }
  .living-entry-label {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin: 0;
  }
  .living-entry-title {
    font-size: 15px;
    color: #333;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .living-entry-icon {
    width: 60px;
    height: 60px;
    object-fit: contain;
    margin-left: 12px;
    flex-shrink: 0;
  }
}
</style>
